import { createRouter, createWebHistory } from 'vue-router';

import Notfound from '@/module/Static/Notfound/page/Notfound.vue';
// page
import Home from '@/module/Home/page/Home.vue';
import Search from '@/module/Search/page/Search.vue';
import Campaign from '@/module/Detail/page/Campaign.vue';
import Favourite from '@/module/History/page/Favourite.vue';
import HistoryPointPage from '@/module/History/page/HistoryPointPage.vue';
import HistoryCoupon from '@/module/History/page/History.vue';
import Mission from '@/module/Mission/page/Mission.vue';
import MissionDetail from '@/module/Mission/component/MissionDetail.vue';
import MissionDetailAndCondition from '@/module/Mission/page/MissionDetailAndCondition.vue';
import TransactionDetail from '@/module/Mission/page/TransactionDetail.vue';
import UnderConstruction from '@/module/Static/UnderConstruction/page/UnderConstruction.vue';
import Landing from "@/module/Landing/Landing.vue";
import Error from '@/module/Static/Error/page/Error.vue';
import GetFriendPage from '@/module/History/page/GetFriendPage.vue';
import GetFriendHistory from '@/module/History/page/HistoryGetFriend.vue';
import Survey from '@/module/Survey/page/Survey.vue';
import ScoreOverview from '@/module/ScoreOverview/page/ScoreOverview.vue';
// Financial Health
import FinancialHealthMain from '@/module/FinancialHealth/page/FinancialHealthMain.vue';
import FinancialHealthQuiz from '@/module/FinancialHealth/page/FinancialHealthQuiz.vue';
import FinancialHealthResult from '@/module/FinancialHealth/page/FinancialHealthResult.vue';
//for test only
import Test from '@/module/Test/Test.vue';

const routes = [
    {
        path: '/',
        name: 'default',
        component: Home
    },
    {
        path: '/category/:catId',
        name: 'default category',
        component: Home
    },
    {
        path: '/home',
        name: 'home',
        component: Home
    },
    {
        path: '/search',
        name: 'search',
        component: Search
    },
    {
        path: '/campaign/:campaignId',
        name: 'campaign',
        component: Campaign,
    },
    {
        path: '/favourite',
        name: 'history-favourite',
        component: Favourite,
    },
    {
        path: '/history/point',
        name: 'history-point',
        component: HistoryPointPage,
    },
    {
        path: '/history',
        name: 'history-coupon',
        component: HistoryCoupon,
    },
    {
        path: '/getfriend',
        name: 'history-getfriend',
        component: GetFriendPage,
    },
    {
        path: '/getfriend/history',
        name: 'history-getfriend-list',
        component: GetFriendHistory,
    },
    {
        path: '/mission',
        name: 'mission',
        component: Mission
    },
    {
        path: '/mission/detail',
        name: 'mission-detail',
        component: MissionDetail
    },
    {
        path: '/mission/detailandcondition/:type',
        name: 'mission-detail-condition',
        component: MissionDetailAndCondition
    },
    {
        path: '/mission/detailandcondition/:type/:key',
        name: 'mission-detail-condition-key',
        component: MissionDetailAndCondition
    },
    {
        path: '/mission/transactiondetail/:missionId',
        name: 'transaction-detail',
        component: TransactionDetail
    },
    {
        path: '/survey/:surveyId',
        name: 'survey',
        component: Survey
    },
    {
        path: '/score-overview',
        name: 'score-overview',
        component: ScoreOverview
    },
    {
        path: '/financial-health',
        name: 'financial-health',
        component: FinancialHealthMain
    },
    {
        path: '/financial-health/quiz',
        name: 'financial-health-quiz',
        component: FinancialHealthQuiz
    },
    {
        path: '/financial-health/result',
        name: 'financial-health-result',
        component: FinancialHealthResult
    },
    {
        path: '/test',
        name: 'test',
        component: Test
    },
    {
        path: '/landing',
        name: 'landing',
        component: Landing
    },
    {
        path: '/error',
        component: Notfound,
    },
    {
        path: '/error/:id/:code',
        name: 'error',
        component: Error,
    },
    {
        path: '/underconstruction',
        component: UnderConstruction,
    },
    {
        path: '/:catchAll(.*)',
        component: Notfound,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
